import PersonStandingIcon from '@material-design-icons/svg/filled/accessibility_new.svg?component'
import _ from 'lodash'
import { Component } from 'react'
import { MdAdd, MdArrowForward } from 'react-icons/md'
import { connect } from 'react-redux'
import access from 'shared_src/access'

import { ability } from '../../../ability'
import { Action, Permission } from '../../../ability/types'
import CMIcon from '../../../assets/svgs/cm.svg?component'
import RIcon from '../../../assets/svgs/r.svg?component'
import { withLegacyRouter } from '../../../decorators'
import { selectTab } from '../../../store/modules/sidebar'
import { ChatType } from '../../chats'
import * as EncounterActions from '../../Encounter/actions'
import { continueEncounterCheck } from '../../Encounter/actions'
import { withLegacySidebar } from '../../layout/context'
import { SidebarOptionKind } from '../../layout/sidebar/types'
import { showCaseManagementModal } from '../../PatientFolder/CaseManagement/actions'
import { CircularProgress, FloatingActionButton } from '../../shared/NarusMaterial'

import './styles.scss'

export class FAB extends Component {
  constructor (props) {
    super(props)
    this.continueToEncounter = this.continueToEncounter.bind(this)
    this.showCaseManagement = this.showCaseManagement.bind(this)
    this.startEncounter = this.startEncounter.bind(this)
    this.isAllowed = this.isAllowed.bind(this)
    this.continueEncounter = this.continueEncounter.bind(this)
    this.state = { continueEncounterLoading: false }
  }

  startEncounter = (type, meta = {}) => {
    const { auth, params, dispatch, navigate, sidebarState, setSidebarState, onEncounterOpen } = this.props
    let redirectTo = 'igao'
    const role = _.get(auth, 'profile.app_metadata.roles', [])[`${params.clientName}-compassion`]
    if (role === 'administrative_support') {
      redirectTo = 'standarddemographicspatient'
    }

    dispatch(
      EncounterActions.encounterStart(
        params.id,
        auth.profile,
        type,
        meta,
        redirectTo,
        navigate,
        () => {
          if (onEncounterOpen === 'open-chats') {
            if (sidebarState !== SidebarOptionKind.messages) {
              setSidebarState(SidebarOptionKind.messages)
              dispatch(selectTab(ChatType.Current))
            }
          }

          if (onEncounterOpen === 'open-encounter-summary') {
            if (sidebarState !== SidebarOptionKind.encounter_summary) {
              setTimeout(() => {
                setSidebarState(SidebarOptionKind.encounter_summary)
              }, 500)
            }
          }
        }
      )
    )
  }

  showCaseManagement = () => {
    const { dispatch } = this.props
    dispatch(showCaseManagementModal())
  }

  isAllowed (allowRules) {
    const { auth, params, episodeOfCare } = this.props
    const roles = [ _.get(auth, 'profile.app_metadata.roles', [])[`${params.clientName}-compassion`] ]

    const isRolesValid =
      _.intersectionWith(roles, allowRules.roles, _.isEqual).length > 0

    let isRulesValid = true
    const rules = _.get(allowRules, 'rules', [])

    if (rules.length > 0) {
      rules.forEach(rule => {
        isRulesValid = isRulesValid && rule(auth, episodeOfCare)
      })
    }

    return isRolesValid && isRulesValid
  }

  continueToEncounter () {
    const { auth, params, navigate } = this.props

    const role = _.get(auth, 'profile.app_metadata.roles', [])[`${params.clientName}-compassion`]
    if (role === 'administrative_support') {
      navigate(`/patient/${params.clientName}/${params.id}/assessment/standarddemographicspatient`)
    } else {
      navigate(`/patient/${params.clientName}/${params.id}/assessment/igao`)
    }

    this.setState({
      continueEncounterLoading: false
    })
  }

  continueEncounter () {
    const { dispatch, params, auth, sidebarState, setSidebarState, onEncounterOpen } = this.props

    if (onEncounterOpen === 'open-chats') {
      if (sidebarState !== SidebarOptionKind.messages) {
        setSidebarState(SidebarOptionKind.messages)
        dispatch(selectTab(ChatType.Current))
      }
    }

    if (onEncounterOpen === 'open-encounter-summary') {
      if (sidebarState !== SidebarOptionKind.encounter_summary) {
        setTimeout(() => {
          setSidebarState(SidebarOptionKind.encounter_summary)
        }, 500)
      }
    }

    this.setState({
      continueEncounterLoading: true
    })

    dispatch(continueEncounterCheck(params.id, auth.profile, null, this.continueToEncounter, params.clientName))
  }

  buttonLoader () {
    return (
      <div
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <CircularProgress type='tiny' />
      </div>
    )
  }

  renderContinueEncounterFAB () {
    return (
      <FloatingActionButton
        onClick={() => this.continueEncounter()}
        title='Continue Encounter'
      >
        {this.state.continueEncounterLoading
          ? this.buttonLoader()
          : (
            <MdArrowForward fill='white' />
          )
        }
      </FloatingActionButton>
    )
  }

  renderFAB () {
    const { encounter } = this.props
    if (encounter._loading) {
      return <CircularProgress type='small' />
    }

    return (
      <FloatingActionButton title='Select Encounter Type'>
        <div>
          <MdAdd color='#fff' />
        </div>

        {this.isAllowed(access.patient) && (
          <button
            onClick={() => this.startEncounter('patient')}
            title='Create New Patient Encounter'
            className='icon-btn'
          >
            <div className='icon-wrapper'>
              <PersonStandingIcon style={{ transform: 'scale(0.95)' }} />
            </div>
          </button>
        )}

        {/* {this.isAllowed(access.grandRounds) */}
        {/*  ? ( */}
        {/*    <button */}
        {/*      title='Create New Grand Round Reports Encounter' */}
        {/*      onClick={() => this.startEncounter('grandRounds')} */}
        {/*      className='icon-btn' */}
        {/*    > */}
        {/*      <div className='icon-wrapper'> */}
        {/*        <GrandRoundsIcon /> */}
        {/*      </div> */}
        {/*    </button> */}
        {/*  ) */}
        {/*  : null} */}

        {this.isAllowed(access.cms) && ability.can(Action.ALL, Permission.NEW_REPORT_ENCOUNTER) && (
          <button
            onClick={() => this.startEncounter('cms')}
            title='Create New Report Encounter'
            className='icon-btn'
          >
            <div className='icon-wrapper'>
              <RIcon />
            </div>
          </button>
        )}

        {this.isAllowed(access.caseManagement) && ability.can(Action.ALL, Permission.CASE_MANAGEMENT) && (
          <button
            onClick={this.showCaseManagement}
            title='Show Case Management Form'
            className='icon-btn'
          >
            <div className='icon-wrapper'>
              <CMIcon style={{ transform: 'scale(1.3)' }} />
            </div>
          </button>
        )}
      </FloatingActionButton>
    )
  }

  render () {
    const { encounter, auth } = this.props
    const sub = _.get(auth, 'profile.sub', [])

    return (
      <div className='new-encounter row'>
        <div className='col-xs-11 col-xs-offset-1'>
          {encounter && (!encounter.encounter || encounter.encounter.author_id !== sub)
            ? this.renderFAB()
            : this.renderContinueEncounterFAB()}
        </div>
      </div>
    )
  }
}

const mapStateToProps = redux => ({
  encounter: redux.encounter,
  auth: redux.auth,
  episodeOfCare: Object.values(
    _.get(redux, 'patient.compartment.EpisodeOfCare', {})
  )[0],
  onEncounterOpen: _.get(redux, 'profile.profile.on_encounter_open', null)
})

export default connect(mapStateToProps /* , mapDispatchToProps */)(withLegacySidebar(withLegacyRouter(FAB)))
